import cookies from 'browser-cookies';
import getParameterByName from './utils/url';

export default function createAffiliate() {
  if (getParameterByName('mbsy') && getParameterByName('campaignid')) {
    cookies.set('ok_mbsysc', getParameterByName('mbsy'), {
      expires: 45,
      path: '/',
      sameSite: 'Strict',
    });

    cookies.set('ok_mbsycid', getParameterByName('campaignid'), {
      expires: 45,
      path: '/',
      sameSite: 'Strict',
    });
  }
}
